import { render, staticRenderFns } from "./storeDayReport.vue?vue&type=template&id=2bf2e9ad&scoped=true"
import script from "./storeDayReport.vue?vue&type=script&lang=js"
export * from "./storeDayReport.vue?vue&type=script&lang=js"
import style0 from "./storeDayReport.vue?vue&type=style&index=0&id=2bf2e9ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2e9ad",
  null
  
)

export default component.exports